import * as React from 'react'

import { MultiSelect } from '@workwave-tidal/core/components'
import Box from '@mui/material/Box'
import FormHelperText from '@mui/material/FormHelperText'
import Stack from '@mui/material/Stack'

import { useData, useHandlers } from './hooks'

export function AttributeValue() {
  const { options, label, value, errorText, placeholder } = useData()
  const { getId, handleChange, isOptionEqual, getLabel, getOptionDisabled } =
    useHandlers()

  return (
    <Stack position="relative" pb={2}>
      <MultiSelect<any>
        items={options}
        label={label}
        optionMode="normal"
        inputMode="normal"
        density="normal"
        hideCheckbox={false}
        value={value}
        getLabel={getLabel}
        onChange={handleChange}
        getId={getId}
        getOptionDisabled={getOptionDisabled}
        placeholder={`Search ${placeholder}`}
        error={!!errorText}
        autocompleteProps={{
          isOptionEqualToValue: isOptionEqual,
          ListboxProps: {
            style: { maxHeight: '25vh' },
          },
        }}
        textFieldProps={{
          InputProps: {
            size: 'medium',
          },
        }}
        maxSelectedItemsToShow={4}
        maxSelectedItemsToShowOnFocus={4}
        // renderSummary={(options) => renderSummary(options, attribute)}
      />
      <Box ml={1.4} position="absolute" bottom={0}>
        <FormHelperText error>{errorText}</FormHelperText>
      </Box>
    </Stack>
  )
}
